import { render, staticRenderFns } from "./ModalCambiarBoletaAFactura.vue?vue&type=template&id=21f0a2ee&scoped=true&lang=pug"
import script from "./ModalCambiarBoletaAFactura.vue?vue&type=script&lang=js"
export * from "./ModalCambiarBoletaAFactura.vue?vue&type=script&lang=js"
import style0 from "./ModalCambiarBoletaAFactura.vue?vue&type=style&index=0&id=21f0a2ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f0a2ee",
  null
  
)

export default component.exports